import React from 'react';

import {
  LoadingOutlined
} from '@ant-design/icons';

import {
  Spin
} from 'antd';

import useMap from '@terrestris/react-geo/dist/Hook/useMap';
import MapComponent, {
  MapComponentProps
} from '@terrestris/react-geo/dist/Map/MapComponent/MapComponent';

import {
  useAppSelector
} from '../../hooks/useAppSelector';

import './index.less';

export const BasicMapComponent: React.FC<Partial<MapComponentProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const isLoading = useAppSelector(state => state.isLoading);

  const map = useMap();

  if (!map) {
    return <></>;
  }

  return (
    <div
      className='map-component'
    >
      <Spin
        spinning={isLoading}
        indicator={
          <LoadingOutlined
            spin
          />
        }
      >
        <MapComponent
          map={map}
          {...passThroughProps}
        />
      </Spin>
    </div>
  );
};

export default BasicMapComponent;
